class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);
    const toggleBtn = summary && summary.querySelector('.mega-menu__toggle');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.toggleBtn = this.summary && this.summary.querySelector('.mega-menu__toggle');
    this.parentLink = this.summary && this.summary.querySelector('.mega-menu__parent-link');
    this.desktopMenuQuery = window.matchMedia('(min-width: 990px)');
    this.hoverCloseTimer = null;

    if (this.parentLink) {
      this.parentLink.addEventListener('click', (e) => e.stopPropagation());
    }
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.mainDetailsToggle.open = !this.mainDetailsToggle.open;
        this.toggleBtn.setAttribute('aria-expanded', this.mainDetailsToggle.open);
      });
    }

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    if (!this.desktopMenuQuery.matches) return;
    clearTimeout(this.hoverCloseTimer);
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.openFromHover();
  }

  onMouseLeave() {
    if (!this.desktopMenuQuery.matches) return;
    this.hoverCloseTimer = setTimeout(() => this.close(), 120);
  }

  openFromHover() {
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    if (this.summary) this.summary.setAttribute('aria-expanded', 'true');
    if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  onToggle() {
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute('aria-expanded', this.mainDetailsToggle.open);
    }
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

function bindHeaderSubmenuHover() {
  const desktopMenuQuery = window.matchMedia('(min-width: 990px)');

  document.querySelectorAll('.header__inline-menu .header__submenu details').forEach((details) => {
    let closeTimer;

    details.addEventListener('mouseenter', () => {
      if (!desktopMenuQuery.matches) return;
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });

    details.addEventListener('mouseleave', () => {
      if (!desktopMenuQuery.matches) return;
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 120);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindHeaderSubmenuHover);
} else {
  bindHeaderSubmenuHover();
}
